import { useEffect, useState } from 'react';

import Spinner from '../../../../reusable/spinner/spinner.component';
import Client from '../../../../../tools/client';

import {
  Container,
  FieldGroup,
  FieldSection,
  Label,
  Input,
  ButtonRow,
  Button,
  TextSmall,
  Toggle
} from '../../configuration-sections.styles';

const client = new Client();

const ShippingConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    const fetchConfig = async () => {
      const res = await client.setup();
      const shipping = res.configuration?.shop?.shipping || {};
      setForm({
        freeShippingActive: shipping.freeShipping?.active === 'true' || shipping.freeShipping?.active === true,
        freeShippingMinimum: shipping.freeShipping?.minimum || '',
        perItemActive: shipping.perItem?.active === 'true' || shipping.perItem?.active === true
      });
      setLoading(false);
    };
    fetchConfig();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleToggle = (key) => {
    setForm({ ...form, [key]: !form[key] });
  };

  const handleSave = async () => {
    await client.updateConfigurationByKey('shop.shipping.freeShipping.active', {
      value: String(form.freeShippingActive),
    });
    await client.updateConfigurationByKey('shop.shipping.freeShipping.minimum', {
      value: form.freeShippingMinimum,
    });
    await client.updateConfigurationByKey('shop.shipping.perItem.active', {
      value: String(form.perItemActive),
    });
    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <Container>
      <FieldSection>
        <FieldGroup>
          <Label>Free Shipping Active</Label>
          <TextSmall>
            Toggle whether free shipping is offered when the customer's order meets a minimum subtotal.
          </TextSmall>
          <Toggle>
            <input
              type="checkbox"
              checked={form.freeShippingActive}
              onChange={() => handleToggle('freeShippingActive')}
              disabled={!editing}
            />
            <span />
          </Toggle>
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="freeShippingMinimum">Free Shipping Minimum (in cents)</Label>
          <TextSmall>
            Set the minimum subtotal (in cents) that a customer must reach to qualify for free shipping.
          </TextSmall>
          <Input
            name="freeShippingMinimum"
            value={form.freeShippingMinimum}
            onChange={handleChange}
            disabled={!editing}
          />
        </FieldGroup>

        <FieldGroup>
          <Label>Shipping Per Item Mode</Label>
          <TextSmall>
            When enabled, each product can define its own shipping type and cost. Useful for mixed-shipping catalogs.
          </TextSmall>
          <Toggle>
            <input
              type="checkbox"
              checked={form.perItemActive}
              onChange={() => handleToggle('perItemActive')}
              disabled={!editing}
            />
            <span />
          </Toggle>
        </FieldGroup>
      </FieldSection>

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </Container>
  );
};

export default ShippingConfigurationDisplay;